import { PortalSDK, PortalSDKArgs, PortalSDKMessage } from "./PortalSDK";

export class GameDistribution extends PortalSDK {
    private _interstitialAdCallback: (() => void) | null;
    private _rewardedAdCallback: ((success: boolean) => void) | null;

    constructor(gameId: string, args: PortalSDKArgs) {
        super(args);
        //@ts-ignore
        window["GD_OPTIONS"] = {
            gameId: gameId,
            onEvent: (event: any) => {
                switch (event.name) {
                    case "SDK_GAME_START":
                        this._interstitialAdCallback &&
                            this._interstitialAdCallback();
                        this._interstitialAdCallback = null;
                        this._resumeAndUnmuteGame();
                        break;
                    case "SDK_GAME_PAUSE":
                        this._pauseAndMuteGame();
                        break;
                    case "SDK_GDPR_TRACKING":
                        // this event is triggered when your user doesn't want to be tracked
                        break;
                    case "SDK_GDPR_TARGETING":
                        // this event is triggered when your user doesn't want personalised targeting of ads and such
                        break;
                    case "SDK_REWARDED_WATCH_COMPLETE":
                        this._rewardedAdCallback &&
                            this._rewardedAdCallback(true);
                        this._rewardedAdCallback = null;
                        this._resumeAndUnmuteGame();
                        break;
                    case "AD_ERROR":
                        this._interstitialAdCallback &&
                            this._interstitialAdCallback();
                        this._interstitialAdCallback = null;
                        this._resumeAndUnmuteGame();
                        break;
                }
            },
        };
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s) as HTMLScriptElement;
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";
            //@ts-ignore
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "gamedistribution-jssdk");
        this._args.onInit();

        setInterval(() => {
            if (!this._rewardedAdReady) {
                this._loadRewardedAd();
            }
        }, 1000 * 30);
    }

    protected _loadRewardedAd() {
        if (
            window.gdsdk !== "undefined" &&
            window.gdsdk.preloadAd !== "undefined"
        ) {
            window.gdsdk
                .preloadAd("rewarded")
                .then((_: any) => {
                    this._rewardedAdReady = true;
                })
                .catch((_: any) => {
                    this._rewardedAdReady = false;
                });
        }
    }

    protected _sdkMessage(m: PortalSDKMessage): void {
        switch (m.type) {
            case "showAd":
                this._showAd(m.callback);
                break;
            case "showRewardedAd":
                this._showRewardedAd(m.callback);
                break;
        }
    }

    protected _showAd(callback: () => void): void {
        if (
            typeof window.gdsdk !== "undefined" &&
            window.gdsdk.showAd !== "undefined"
        ) {
            this._pauseAndMuteGame();
            this._interstitialAdCallback = callback;
            window.gdsdk.showAd();
        }
    }

    protected _showRewardedAd(callback: (success: boolean) => void): void {
        if (!this._rewardedAdReady) {
            this._rewardedAdCallback && this._rewardedAdCallback(false);
            return;
        }
        if (
            window.gdsdk !== "undefined" &&
            window.gdsdk.showAd !== "undefined"
        ) {
            this._rewardedAdCallback = callback;
            this._pauseAndMuteGame();
            window.gdsdk
                .showAd("rewarded")
                .then((_: any) => {
                    // Ad process done. You can track "SDK_REWARDED_WATCH_COMPLETE" event if that event triggered, that means the user watched the advertisement completely, you can give reward there.
                })
                .catch((_: any) => {
                    this._rewardedAdCallback && this._rewardedAdCallback(false);
                    this._resumeAndUnmuteGame();
                });
        }
    }
}
